import { render, staticRenderFns } from "./html/RecommendedItems.html?vue&type=template&id=8a7b03d0&lang=html&external"
import script from "./js/RecommendedItems.js?vue&type=script&lang=js&external"
export * from "./js/RecommendedItems.js?vue&type=script&lang=js&external"
import style0 from "./scss/RecommendedItems.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports